var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconsettingscareUser = function SvgIconsettingscareUser(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Settings/CareUser") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Settings/CareUser",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z",
    id: "Background",
    fill: "#D9E8E3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Circle",
    transform: "translate(7.000000, 6.500000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_28",
    fill: "#FFFFFF",
    cx: 5,
    cy: 6.05,
    rx: 4,
    ry: 4.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95787062,0.550173912 C6.29724528,0.539019337 7.58418916,1.06486461 8.52572437,2.00799895 C9.47566805,2.91430753 10.0085316,4.16669519 9.99989666,5.47274172 C9.99989666,8.22154907 7.74903946,10.4498977 4.97246639,10.4498977 C3.65322747,10.4584463 2.38818942,9.93091137 1.47272621,8.99046712 C0.520065259,8.05834727 -0.011091579,6.78427283 0.000175668377,5.45829192 C0.0376828234,2.76314364 2.23549862,0.587305995 4.95787062,0.550173912 Z M7.59808239,2.85893207 C6.89448544,2.17647528 5.94265064,1.8037162 4.95787062,1.82496805 C3.97150809,1.79291073 3.01579101,2.16675541 2.31795163,2.85761639 C1.62011226,3.54847737 1.24249137,4.49463728 1.27487251,5.47113619 C1.25340598,6.44606841 1.62993031,7.38838486 2.3192806,8.08494584 C3.02303937,8.77426103 3.96957787,9.16624309 4.95949237,9.17831462 C7.02097567,9.16258805 8.68823163,7.51200465 8.70411705,5.47113619 C8.69107219,4.49145273 8.29456755,3.55499831 7.59808239,2.85893207 L7.59808239,2.85893207 Z",
    id: "Path_513",
    fill: "#09BE86"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconsettingscareUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.settings.care_user.c6cd4f2004c56b4daf768fcc676dbe7c.svg";